import { render } from "./GroupCard.vue?vue&type=template&id=42c47c2d"
import script from "./GroupCard.vue?vue&type=script&lang=js"
export * from "./GroupCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__